import { planningAPI } from "../../axios";

export const actions = {
    //Planning Target Department
    CreatePlanningTargetDepartment(context, data){
        return planningAPI.post(`PlanningTargetDepartment/Add`, data);
    },
    RemovePlanningTargetDepartment(context, data){
        return planningAPI.delete(`PlanningTargetDepartment/Remove/${data}`);
    },
    GetPlanningTargetDepartment(context, data){
        return planningAPI.get(`PlanningTargetDepartment/PlanningTarget/${data}`);
    },
    GetTargetsByDepartment(context, data){
        return planningAPI.get(`PlanningTargetDepartment/Department/${data}`);
    },
}